import { createUseStyles } from "react-jss";
import colors from "../../constants/colors";

// TODO sistema le dimensioni bottone

export const styles = createUseStyles({
  defaultButton: {
    padding: 8,
    height: "fit-content",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    outline: "none",
    cursor: "pointer",
    borderRadius: 25,
    border: "none",
    boxSizing: "border-box",
    color: colors.button.color.primary,
    "& *": {
      pointerEvents: "none",
    },
  },
  label: {
    paddingLeft: 10,
    paddingRight: 10,
    fontFamily: "'Poppins', sans-serif",
    fontWeight: 500,
    fontSize: "1rem",
    letterSpacing: 0.5,
    textTransform: "uppercase",
    whiteSpace: "nowrap",
  },
  primary: {
    backgroundColor: colors.button.background.primary,
    color: colors.button.color.primary,
    "&:hover": {
      filter: "brightness(90%)",
      transition: "all 0.5s ease",
      color: colors.white,
    },
    "&a:hover": {
      color: colors.white,
      filter: "brightness(90%)",
      transition: "all 0.5s ease",
    },
  },
  secondary: {
    borderColor: colors.button.color.secondary,
    backgroundColor: colors.button.background.secondary,
    color: colors.black,
    border: "1px solid",
    "&:hover": {
      filter: "brightness(90%)",
      transition: "all 0.5s ease",
      color: colors.black,
    },
    "&a:hover": {
      color: colors.black,
      filter: "brightness(90%)",
      transition: "all 0.5s ease",
    },
  },
  warning: {
    borderColor: colors.white,
    backgroundColor: colors.orange,
    color: colors.white,
    border: "1px solid",
    "&:hover": {
      filter: "brightness(90%)",
      transition: "all 0.5s ease",
      color: colors.white,
    },
    "&a:hover": {
      color: colors.white,
      filter: "brightness(90%)",
      transition: "all 0.5s ease",
    },
  },
  disabled: {
    backgroundColor: colors.button.background.disabled,
    color: colors.button.color.secondary,
    cursor: "not-allowed",
    "&:hover": {
      //filter: 'brightness(90%)',
      filter: "unset",
    },
  },
  error: {
    borderColor: colors.white,
    backgroundColor: colors.button.background.red,
    color: colors.white,
    border: "1px solid",
    "&:hover": {
      filter: "brightness(90%)",
      transition: "all 0.5s ease",
      color: colors.white,
    },
    "&a:hover": {
      color: colors.white,
      filter: "brightness(90%)",
      transition: "all 0.5s ease",
    },
  },
  mini: {
    padding: "2px",
    lineHeight: "22px",
    textAlign: "center",
    minWidth: "100px",
  },
  miniPrimary: {
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: colors.button.color.primary,
  },
  miniLabel: {
    fontSize: "16px",
    textTransform: "none",
    fontWeight: "normal",
  },
  miniDisabled: {
    cursor: "not-allowed",
  },
  ai: {
    backgroundColor: colors.white,
    border: "3px solid #597DFFCC",
    marginRight: 8,
    boxShadow: "2px 2px 4px rgba(0, 0, 0, 0.25)",
    height: "42px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    padding: "0 16px",
    minWidth: "180px",
    width: "max-content",
    color: colors.ai.darkBlue,
    fontWeight: 600,
    flexShrink: 0,
    whiteSpace: "nowrap",
    transition: "border-color 0.2s ease",
    "&:hover": {
      borderColor: "#597DFF",
    },
  },
});

export default styles;
